import React from 'react';
import { string, shape } from 'prop-types';

import './store-callout.scss';

export const StoreCallout = ({ storeInfo }) => {
  return (
    <div className="rental-pricing--copy">
      <div className="store-pricing">
        Rental Pricing for { storeInfo.storeName } #{ storeInfo.storeId }
      </div>
      <div className="exact-pricing">Exact pricing will be determined at the store.</div>
    </div>
  );
};

StoreCallout.displayName = 'StoreCallout';

StoreCallout.propTypes = {
  storeInfo: shape({
    storeName: string.isRequired,
    storeId: string.isRequired
  }).isRequired
};